<template>
  <div class="card-box">
    <OnlineCard :zhsRole="zhsRole" :onlineLink="onlineLink" />
    <template v-if="uuid()">
      <ul class="menu-list" v-if="zhsRole == 3 || zhsRole == 0">
        <li
          class="menu-item"
          v-for="item in menuList"
          :key="item.name"
          @click="handleLink(item.jump_url)"
        >
          <div class="left">
            <img :src="item.icon_url" alt="" class="menu-icon" />
            <span class="menu-title">{{ item.app_name }}</span>
          </div>
          <i class="iconfont icon-chakanquanbu arrow-icon"></i>
        </li>
      </ul>
      <ul class="menu-card" v-else>
        <li
          class="card-item"
          v-for="item in menuList"
          :key="item.name"
          @click="handleLink(item.jump_url)"
        >
          <img :src="item.icon_url" class="card-icon" alt="" />
          <span class="card-text">{{ item.app_name }}</span>
        </li>
      </ul>
    </template>

    <div class="bind-box" v-else>
      <div class="bind-tips-box">
        <img class="bind-img" src="@/assets/images/bind_img.png" alt="" />
        <div class="bind-tips">
          <div>绑定智慧树账号</div>
          <div>优享更多服务</div>
        </div>
      </div>
      <el-button class="bind-btn" type="primary" round @click="goToBind">去绑定 ></el-button>
    </div>
  </div>
  <!-- 提示 -->
  <TipDialog v-model:show="showDialog" />
</template>

<script>
import TipDialog from './TipDialog.vue'
import OnlineCard from './OnlineCard.vue'
export default {
  components: {
    TipDialog,
    OnlineCard
  },
  props: {
    menuList: Array,
    zhsRole: Number, // 角色
    onlineLink: String // 在线学堂链接
  },
  inject: ['uuid', 'userId'],
  data() {
    return {
      showDialog: false,
      home_zhs_bind_sso: false
    }
  },
  created() {
    this.getBindZhsType()
  },
  methods: {
    async getBindZhsType() {
      const data = await this.$http.getBindZhsType()
      this.home_zhs_bind_sso = data.some(item => item.key == 'home_zhs_bind_sso')
    },
    handleLink(url) {
      if (url) {
        window.open(url)
      } else {
        this.showDialog = true
      }
    },
    goToBind() {
      const host = window.location.origin
      if (this.home_zhs_bind_sso) {
        window.location.href = `${host}/homepage/hike-boot/ssoLogin/zhsSsoLogin?redirectUri=${host}`
      } else {
        const userId = this.userId()
        window.location.href = `${host}/homepage/hike-boot/AuthSys/getAuthorize?failRedirectUri=${host}&redirectUri=${host}&userId=${userId}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-box {
  width: 100%;
}

.menu-card {
    // width: 64%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
     margin-top: 24px;
    // margin-left: 18%;
  .card-item {
    width: 25%;
    text-align: center;
    margin-bottom: 16px;
    cursor: pointer;
    .card-icon {
      width: 28px;
      height: 28px;
      border-radius: 50%;
    }
    .card-text {
      font-weight: 400;
      font-size: 14px;
      color: #1D2129;
      display: block;
      margin-top: 6px;
    }
  }
}

.bind-box {
  margin: 20px 0;
  padding: 20px 0;
  .bind-tips-box {
    display: flex;
    align-items: center;
    .bind-img {
      width: 77px;
      margin-left: 33px;
    }
    .bind-tips {
      margin-left: 14px;
      font-size: 16px;
      color: #191d26;
    }
  }
  .bind-btn {
    margin-top: 20px;
    width: 100%;
    height: 54px;
    border-radius: 27px;
  }
}

.menu-list {
  height: 200px;
    overflow-y: scroll;
  .menu-item {
   width: 60%;
    margin-left: 20%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 20px;
    background: #fff;
    margin-top: 10px;
    cursor: pointer;
    .left {
      display: flex;
      align-items: center;
      .menu-icon {
        width: 28px;
        height: 28px;
      }
      .menu-title {
        color: #191d26;
        font-size: 14px;
        margin-left: 14px;
      }
    }
    .arrow-icon {
      color: #8b8b8b;
    }
  }
}
</style>
